import ky from 'ky';

let rivaasSessionToken = '';

/** Sets the DIS/BFF session token used as `x-session-token` on each request. */
export function setRivaasSessionToken(token: string) {
  rivaasSessionToken = token;
}

export const rivaasHttp = ky.create({
  prefixUrl: `${import.meta.env.VITE_APP_RIVAAS_SERVICE_URL}/bff/api/v1`,
  // The final capture `submit` blocks server-side on `client.workflow.execute()` (BFF
  // dispatches the BackendSegmentWorkflow synchronously and returns its terminal verdict in
  // the response — see apps/bff submit.service.ts). That workflow (tf_eval + matching +
  // decision + customer-store merge) routinely takes ~8-15s, well past ky's 10s default, so
  // the request would abort and render a spurious "unexpected error" even though the workflow
  // completed (accept/merge). Give it comfortable headroom.
  timeout: 60_000,
  hooks: {
    beforeRequest: [
      (request) => {
        if (!rivaasSessionToken) {
          return;
        }

        const headers = new Headers(request.headers);

        headers.set('x-session-token', rivaasSessionToken);

        return new Request(request, { headers });
      },
    ],
  },
});
